"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyResultsExportCommand = exports.SurveyResultsViewHTMLCommand = exports.SurveyResultsViewCommand = exports.SurveyResultsCommands = void 0;
const Command_1 = require("../../_shared/commands/Command");
var SurveyResultsCommands;
(function (SurveyResultsCommands) {
    SurveyResultsCommands["View"] = "survey/results/view";
    SurveyResultsCommands["Export"] = "survey/results/export";
    SurveyResultsCommands["ViewHtml"] = "survey/results/view/html";
})(SurveyResultsCommands = exports.SurveyResultsCommands || (exports.SurveyResultsCommands = {}));
function SurveyResultsViewCommand(surveyId, page) {
    const data = Object.assign(Object.assign({ surveyId }, page), { command: SurveyResultsCommands.View });
    return new Command_1.Command(data);
}
exports.SurveyResultsViewCommand = SurveyResultsViewCommand;
function SurveyResultsViewHTMLCommand(surveyId, resultsType) {
    const data = {
        surveyId,
        command: SurveyResultsCommands.ViewHtml,
        resultsType,
    };
    return new Command_1.Command(data);
}
exports.SurveyResultsViewHTMLCommand = SurveyResultsViewHTMLCommand;
function SurveyResultsExportCommand(surveyId) {
    const data = {
        surveyId,
        command: SurveyResultsCommands.Export,
    };
    return new Command_1.Command(data);
}
exports.SurveyResultsExportCommand = SurveyResultsExportCommand;
//# sourceMappingURL=SurveyResultsCommands.js.map